import React from 'react'
import { Route, Routes, } from 'react-router-dom';
// import Conversation from 'views/app-views/apps/chat/ConversationOG';
import Conversation from './Conversation';

const ConversationEmpty = () => (
  <div className="chat-content-empty" style={{background:'#fdfdfd'}}>
    <div className="text-center">
      <img src="/img/default-chat.gif" alt="Start a Conversation" width={50} style={{pointerEvents:'none'}}/>
      <h1 className="font-weight-light">Select a Chat to Start Replying...</h1>
    </div>
  </div>
)

const ChatContent = (props) => {
  return (
    <Routes>
      <Route path={`:id`} element={<Conversation {...props}/>} />
      <Route path={`/`} element={<ConversationEmpty />} />
    </Routes>
  )
}

export default ChatContent
